<div class="d-flex w-100 justify-content-between align-items-center flex-column" [ngClass]="{ box: !noBorder }">
  <div class="row mx-0 w-100 justify-content-between align-items-center">
    <div class="d-flex justify-content-start align-items-center" style="margin: 18px;">
      <bdg-label type="body-1" [toolTip]="titleTooltip">{{ title }}</bdg-label>
      <a class="ml-2" *ngIf="filename" href="javascript:void(0)" (click)="download()">{{ filename }}</a>
      <mat-icon class="ml-2" *ngIf="filename">get_app</mat-icon>
    </div>
  </div>
</div>
